import React from 'react';
import { common } from '@kurtosys/ksys-app-template';

import { IDropdownAssets } from '../../Dropdown/models/IDropdownAssets.js';
import { IDropdownItem } from '../../Dropdown/models/IDropdownItem.js';
import { ITranslationContextValue } from '../../Translate/models/ITranslationContextValue.js';
import PageSizeLabel from '../styledComponents/PageSizeLabel.js';
import PageSizeSelector from '../styledComponents/PageSizeSelector.js';
import PageSizeWrapper from '../styledComponents/PageSizeWrapper.js';

interface PageSizeSelectionProps {
	pageSize: number;
	pageSizeOptions: { label: string; value: string }[];
	ariaControls?: string;
	translationContext?: ITranslationContextValue;
	placeholders?: any;
	pageSizeSelection?: {
		label?: string;
		dropdownAssets?: IDropdownAssets;
	};
	handlePageSizeChange: (item: IDropdownItem | IDropdownItem[], index?: number) => void;
}

export const PageSizeSelection: React.FC<PageSizeSelectionProps> = ({
	pageSize,
	pageSizeOptions,
	ariaControls,
	translationContext,
	placeholders,
	pageSizeSelection,
	handlePageSizeChange,
}) => {
	if (pageSizeSelection) {
		const { label, dropdownAssets } = pageSizeSelection;
		const selectedItem = pageSizeOptions.find((option) => option.value === pageSize.toString());
		let ariaLabel = '';
		const defaultAriaLabel = 'Records {aria:PerPage}';

		if (translationContext) {
			ariaLabel = label
				? translationContext.translate(label, placeholders)
				: translationContext.translate(defaultAriaLabel, placeholders);
		} else {
			ariaLabel = label
				? common.commonUtils.replacePlaceholders({ values: placeholders, text: label })
				: common.commonUtils.replacePlaceholders({
						values: placeholders,
						text: defaultAriaLabel,
				  });
		}

		return (
			<PageSizeWrapper aria-label={`${selectedItem && selectedItem.value} ${ariaLabel}`}>
				<PageSizeLabel aria-hidden="true">{label}</PageSizeLabel>
				<PageSizeSelector
					dropdownAssets={dropdownAssets}
					ariaControls={ariaControls}
					onChange={handlePageSizeChange}
					selectedItem={selectedItem}
					items={pageSizeOptions}
				/>
			</PageSizeWrapper>
		);
	}
	return null;
};
